module.exports = __webpack_public_path__ + "aw.no2.76b55839.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/aoyama/child_to_parent/aw.no2.jpg
// module id = 6XsT
// module chunks = 0